import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useUserContext } from '../../core/context/user.context';
import useFetch from '../../core/hooks/useFetch';

const BASE_URL = process.env.REACT_APP_SC_API_BASE;

function Booking() {
  const { id } = useParams();
  const { user } = useUserContext();
  // TODO: add correct endpoint
  const { result, doFetch, loading, error } = useFetch(`${BASE_URL}/admin/booking/${id}`);

  useEffect(() => {
    doFetch({
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }, []);

  return <div className="wrap">{id}</div>;
}

export default Booking;
